import { Link } from 'react-router-dom';

/**
 * A manager's name, wherever it appears, pointing at their profile.
 *
 * One component rather than a Link at each call site so the affordance is the
 * same everywhere: names across the scoreboard, standings, money board, draft
 * board and Clown all behave identically, and the hover is the only thing that
 * says "there's more here" on a page otherwise full of plain text.
 */
export function ManagerLink({
  ownerId,
  children,
  className = '',
}: {
  ownerId: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <Link
      to={`/manager/${encodeURIComponent(ownerId)}`}
      // stopPropagation because some of these sit inside a card that is itself a
      // button (the scoreboard's expanding matchups) — clicking a name should go
      // to the profile, not toggle the lineup underneath it.
      onClick={(e) => e.stopPropagation()}
      className={`hover:text-brass hover:underline ${className}`}
    >
      {children}
    </Link>
  );
}
